"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseGatewaysFromProcessData = void 0;
const index_1 = require("../../../../Errors/index");
const index_2 = require("../../../Model/index");
const TypeFactory_1 = require("../../TypeFactory");
const ExtensionPropertyParser_1 = require("./ActivityParsers/ExtensionPropertyParser");
function parseGatewaysFromProcessData(processData) {
    const exclusiveGateways = parseGatewaysByType(processData, index_2.BpmnTags.GatewayElement.ExclusiveGateway, index_2.Model.Gateways.ExclusiveGateway);
    const eventBasedGateways = parseGatewaysByType(processData, index_2.BpmnTags.GatewayElement.EventBasedGateway, index_2.Model.Gateways.EventBasedGateway);
    const parallelGateways = parseGatewaysByType(processData, index_2.BpmnTags.GatewayElement.ParallelGateway, index_2.Model.Gateways.ParallelGateway);
    const inclusiveGateways = parseGatewaysByType(processData, index_2.BpmnTags.GatewayElement.InclusiveGateway, index_2.Model.Gateways.InclusiveGateway);
    const complexGateways = parseGatewaysByType(processData, index_2.BpmnTags.GatewayElement.ComplexGateway, index_2.Model.Gateways.ComplexGateway);
    return Array.prototype.concat(parallelGateways, exclusiveGateways, eventBasedGateways, inclusiveGateways, complexGateways);
}
exports.parseGatewaysFromProcessData = parseGatewaysFromProcessData;
function parseGatewaysByType(processData, gatewayType, type) {
    const gatewaysRaw = (0, TypeFactory_1.getModelPropertyAsArray)(processData, gatewayType);
    const noGatewaysFound = !((gatewaysRaw === null || gatewaysRaw === void 0 ? void 0 : gatewaysRaw.length) > 0);
    if (noGatewaysFound) {
        return [];
    }
    return gatewaysRaw.map((gatewayRaw) => {
        var _a, _b;
        const flowNodeId = gatewayRaw.id;
        try {
            let gateway = new type();
            gateway = (0, TypeFactory_1.setCommonObjectPropertiesFromData)(gatewayRaw, gateway);
            gateway.name = gatewayRaw.name;
            gateway.defaultOutgoingSequenceFlowId = gatewayRaw.default;
            gateway.incoming = (0, TypeFactory_1.getModelPropertyAsArray)(gatewayRaw, index_2.BpmnTags.FlowElementProperty.SequenceFlowIncoming);
            gateway.outgoing = (0, TypeFactory_1.getModelPropertyAsArray)(gatewayRaw, index_2.BpmnTags.FlowElementProperty.SequenceFlowOutgoing);
            gateway.preScript = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('engine.runPreScript', gateway.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value;
            gateway.postScript = (_b = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('engine.runPostScript', gateway.extensionElements.camundaExtensionProperties)) === null || _b === void 0 ? void 0 : _b.value;
            if (gatewayType === index_2.BpmnTags.GatewayElement.EventBasedGateway && (!gateway.outgoing || gateway.outgoing.length < 2)) {
                const unsupportedErrorMessage = `EventBasedGateway \`${gateway.id}\` requires at least two follow-up Intermediate Catch Events.`;
                throw new index_1.UnprocessableEntityError(unsupportedErrorMessage);
            }
            return gateway;
        }
        catch (error) {
            error.additionalInformation = {
                ...error.additionalInformation,
                flowNodeId: flowNodeId,
            };
            throw error;
        }
    });
}
//# sourceMappingURL=GatewayParser.js.map